import React, { useState, useEffect } from "react";
import getValue from "utils/value-types/get-value/boolean";
import CheckBox from "material-ui/Checkbox";

const CheckboxEditor = ({ value, onChange, disabled }) => {
  const [checked, setChecked] = useState(getValue(value) ?? false);

  useEffect(() => {
    setChecked(getValue(value) ?? false);
  }, [value]);

  const onClick = () => {
    const newValue = !checked;
    setChecked(newValue);
    onChange({
      type: "boolean",
      value: newValue
    });
  };

  return <CheckBox checked={checked} disabled={disabled} onCheck={onClick} />;
};

export default CheckboxEditor;
